module.exports = __webpack_public_path__ + "01_medium_gold.5a9919a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/01_medium_gold.png
// module id = vxtb
// module chunks = 0